import React from 'react';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { createPageUrl } from '@/utils';

export default function PaymentIssueBanner({ subscription }) {
  const navigate = useNavigate();

  // Only show for past_due status
  if (!subscription || subscription.subscription_status !== 'past_due') {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-4 mt-4 mb-2 p-4 rounded-lg border-2 border-yellow-400 bg-yellow-50 dark:bg-yellow-900/20 dark:border-yellow-600"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-6 h-6 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-semibold text-yellow-900 dark:text-yellow-100 mb-1">
            Payment Update Needed
          </h3>
          <p className="text-sm text-yellow-800 dark:text-yellow-200 mb-3">
            We couldn't process your last payment. Don't worry – your account is still active and we'll retry automatically. 
            Please update your payment method to avoid any interruption.
          </p>
          <Button
            onClick={() => navigate(createPageUrl('ManageSubscription'))}
            size="sm"
            className="bg-yellow-600 hover:bg-yellow-700 text-white rounded-[24px]"
          >
            <CreditCard className="w-4 h-4 mr-2" />
            Update Payment Method
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
